// extracted by mini-css-extract-plugin
module.exports = {"type":"guestsPage_type__1Yfow","start":"guestsPage_start__2bT4E"};